import React from 'react';
import { Card, CardContent } from '../ui/card';
import { MapPin, Phone, Mail, Clock, Building2 } from 'lucide-react';

export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Contact Us
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Ready to start your currency exchange? Get in touch with our professional team today.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information - Left Side */}
          <div className="space-y-8">
            <Card className="shadow-lg border-0 bg-gradient-to-br from-blue-900 to-blue-800 text-white">
              <CardContent className="p-0">
                <div className="pt-8 px-8 pb-8">
                  <h3 className="text-2xl font-bold mb-8">Get in Touch</h3>
                  <div className="space-y-6">
                    <div className="flex items-start space-x-4">
                      <Building2 className="w-6 h-6 text-green-400 mt-1" />
                      <div>
                        <p className="font-semibold">Company</p>
                        <p className="text-white font-medium">CustodiaFX sp. z o.o.</p>
                        <p className="text-blue-100">NIP: 5253060756</p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-4">
                      <MapPin className="w-6 h-6 text-green-400 mt-1" />
                      <div>
                        <p className="font-semibold">Office Address</p>
                        <p className="text-blue-100">Marszałkowska 115</p>
                        <p className="text-blue-100">00-102 Warszawa, Polska</p>
                      </div>
                    </div>
                    
                    <div className="flex items-start space-x-4">
                      <Phone className="w-6 h-6 text-green-400 mt-1" />
                      <div>
                        <p className="font-semibold">Phone</p>
                        <a href="tel:+48506864786" className="text-blue-100 hover:text-white transition-colors">
                          +48 506 864 786
                        </a>
                      </div>
                    </div>
                    
                    <div className="flex items-start space-x-4">
                      <Mail className="w-6 h-6 text-green-400 mt-1" />
                      <div>
                        <p className="font-semibold">Email</p>
                        <a href="mailto:office@custodiafx.com" className="text-blue-100 hover:text-white transition-colors">
                          office@custodiafx.com
                        </a>
                      </div>
                    </div>
                    
                    <div className="flex items-start space-x-4">
                      <Clock className="w-6 h-6 text-green-400 mt-1" />
                      <div>
                        <p className="font-semibold">Business Hours</p>
                        <p className="text-blue-100">Mon - Fri: 9:00 - 18:00</p>
                        <p className="text-blue-100">Saturday: 10:00 - 14:00</p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Google Maps - Right Side */}
          <div>
            <Card className="shadow-lg border-0 overflow-hidden h-full">
              <div className="h-full bg-gray-200 relative" style={{ minHeight: '500px' }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2443.5289777!2d21.0123456!3d52.2297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471eccf3e52bee59%3A0x42a2df4a2b5b8e7a!2sMarszałkowska%20115%2C%2000-102%20Warszawa%2C%20Poland!5e0!3m2!1sen!2sus!4v1635429373265!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="CUSTODIA FX Location"
                ></iframe>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
}